/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_TitleInputs */

const tr_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Abonelik Planları`)
};

const en_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Subscription Plans`)
};

const de_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel-Abonnements`)
};

const ru_pricing_hero_title = /** @type {(inputs: Pricing_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Планы подписки ShopPanel`)
};

/**
* | output |
* | --- |
* | "ShopPanel Subscription Plans" |
*
* @param {Pricing_Hero_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_title = /** @type {((inputs?: Pricing_Hero_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_hero_title(inputs)
	if (locale === "de") return de_pricing_hero_title(inputs)
	if (locale === "ru") return ru_pricing_hero_title(inputs)
	return tr_pricing_hero_title(inputs)
});